import { render } from "./Pulmino.vue?vue&type=template&id=10a09564&scoped=true"
import script from "./Pulmino.vue?vue&type=script&lang=js"
export * from "./Pulmino.vue?vue&type=script&lang=js"

import "./Pulmino.vue?vue&type=style&index=0&id=10a09564&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a09564"]])

export default __exports__